/* eslint-disable */

/**
 * Know Your Customer (KYC) State stores information needed by compliance to allow commercial
 * payments.
 */
export enum KycState {
  /** KYC_NEW - KYC_NEW customers are those that haven't been flagged for commercial/KYC review. */
  KYC_NEW = "KYC_NEW",
  /**
   * KYC_NEEDS_REVIEW - Customers are in the KYC_NEEDS_REVIEW state if they have been flagged for commercial/KYC
   * review. They will remain in this state while their regulator case is open, while we are
   * waiting on the IRF responses, etc.
   */
  KYC_NEEDS_REVIEW = "KYC_NEEDS_REVIEW",
  /**
   * KYC_APPROVED - Customers are KYC_APPROVED after we have created a KYC case, potentially contacted them,
   * and approved them for commercial use.
   */
  KYC_APPROVED = "KYC_APPROVED",
  /**
   * KYC_REVIEWED_NONCOMMERCIAL - Customers are KYC_REVIEWED_NONCOMMERCIAL if they were flagged and the subsequent compliance
   * review decided that it was not commercial usage.
   */
  KYC_REVIEWED_NONCOMMERCIAL = "KYC_REVIEWED_NONCOMMERCIAL",
}
